import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    importBy: "",
    statusPercentage: 10,
    importWizardTableColumns: [],
    originalDataTable: [],
    importWizardTable: [],
    validTable: [],
    invalidTable: [],
    apnColumn: "",
    pdeColumn: "",
    supplierColumn: "",
    priceColumn: "",
    fileSheets: [],
    columnsList: [],
    currentSheet: "",
    fileName:"",
    fileSize: "",
    fileWorkBook: {
      Sheet1: {
        A1: { v : "" },
        A2: { v : "" },
        A3: { v : "" },
        A4: { v : "" },
        A5: { v : "" },
        A6: { v : "" },
        A7: { v : "" },
        A8: { v : "" },
        A9: { v : "" },
        A10: { v : "" },
      },  
    },
    fileWorkBookHerader: 1,
    fileLoaded: false,
    readyToProcess: false,
    readyToImport: false,
    isProcessing: false,
    processedStocks: 0,
    totalStocksToImport: 0,
    generalColumnsOptions: [
        { id: 0, name:"Name", slug: "name", columnIndex: null },
    ],
    columnsOptions: [
        { id: 0, name:"Name", slug: "name", columnIndex: null },
        { id: 1, name:"APN", slug: "apn", columnIndex: null },
        { id: 2, name:"PDE", slug: "pde", columnIndex: null },
        { id: 3, name:"Supplier", slug: "supplier", columnIndex: null }, 
        { id: 4, name:"Department", slug: "department", columnIndex: null }, 
        { id: 5, name:"Sub Department", slug: "subDepartment", columnIndex: null }, 
        { id: 6, name:"Stock Group", slug: "stockGroup", columnIndex: null }, 
        { id: 7, name:"Min Order Qty", slug: "minOrderQty", columnIndex: null }, 
        { id: 8, name:"Max Stock",  slug: "maxStock", columnIndex: null }, 
        { id: 9, name:"Min Stock", slug: "minStock", columnIndex: null }, 
        { id: 10, name:"Carton Size", slug: "cartonSize", columnIndex: null }, 
        { id: 11, name:"Cost", slug: "cost", columnIndex: null }, 
        { id: 12, name:"GST", slug: "gst", columnIndex: null }, 
        { id: 13, name:"Sell Price", slug: "sellPrice", columnIndex: null }, 
        { id: 14, name:"RRP", slug: "rrp", columnIndex: null }, 
        { id: 15, name:"Active", slug: "active", columnIndex: null},
        { id: 16, name:"Ethical", slug: "ethical", columnIndex: null},
        { id: 17, name:"Locked", slug: "locked", columnIndex: null},
        { id: 18, name:"Additional Info", slug: "additionalOrderInformation", columnIndex: null},
    ],
};

export const importWizardSlice = createSlice({
    name: "importWizardSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateImportWizardField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanImportWizardDetails: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
        updateRowImportWizardTable: (state, action) => {
            const { index, field, value } = action.payload;
            // @ts-ignore
            state.importWizardTable[index][field] = value;     
        },
        addRowImportWizardTable: (state, action) => {
            const { index, field, value } = action.payload;
            let initialMessage = ", ";
            let separetor = ", ";
            let oldValue = state.importWizardTable[index][field] ? state.importWizardTable[index][field] : "";

            if(state.importWizardTable[index][field] === null) {
                initialMessage = "Invalid ";
                separetor = "";
                oldValue = "";
            } 
             
            if (value !== "" && value !== null && value !== undefined) {
                // Split existing values by separator and check if the new value is already in the list
                let updatedMessage = oldValue.replace(/Invalid /, "");
                const existingValues = updatedMessage.split(", ").map(v => v.trim());
                if (!existingValues.includes(value)) {
                    // If there are no existing values, we don"t want to add a separator at the beginning
                    if (oldValue !== "") {
                        oldValue += separetor;
                    } else {
                        // If oldValue is empty, that means it"s the first value and should be marked as "Invalid"
                        oldValue = initialMessage;
                    }
                    // @ts-ignore
                    state.importWizardTable[index][field] = oldValue + value;
                }
            }
        },
        updateColumnIndex: (state, action) => {
            return {
                ...state,
                columnsOptions: state.columnsOptions.map((column: any) => {
                    if (column.id === action.payload.id) {
                        return {
                            ...column,
                            columnIndex: action.payload.columnIndex,
                        };
                    } else {
                        if(column.columnIndex === action.payload.columnIndex) {
                            return {
                                ...column,
                                columnIndex: null,
                            };
                        }
                    }
                    return column;
                }),
            };
        },
        updateGeneralColumnIndex: (state, action) => {
            return {
                ...state,
                generalColumnsOptions: state.generalColumnsOptions.map((column: any) => {
                    if (column.id === action.payload.id) {
                        return {
                            ...column,
                            columnIndex: action.payload.columnIndex,
                        };
                    } else {
                        if(column.columnIndex === action.payload.columnIndex) {
                            return {
                                ...column,
                                columnIndex: null,
                            };
                        }
                    }
                    return column;
                }),
            };
        },
        addImportWizardTable: (state, action) => {
            // @ts-ignore
            state.importWizardTable = state.importWizardTable.concat(action.payload);
        },
        addStockToValidTable: (state, action) => {
            // @ts-ignore
            state.validTable = state.validTable.concat(action.payload);
        },
        addStockToInvalidTable: (state, action) => {
            // @ts-ignore
            state.invalidTable = state.invalidTable.concat(action.payload);
        },
        addDataToArray: (state, action) => {
            // @ts-ignore
            state[action.payload.key] = state[action.payload.key].concat(action.payload.value);
        }
    },
});

export const { updateGeneralColumnIndex, addRowImportWizardTable, updateRowImportWizardTable, addDataToArray, addStockToValidTable, addStockToInvalidTable, addImportWizardTable, updateColumnIndex, updateImportWizardField, cleanImportWizardDetails } = importWizardSlice.actions;

export default importWizardSlice.reducer;